import React, { Component } from 'react';
import axios from 'axios'
import * as moment from 'moment';
import { getOrderKey, firebaseAuth, pythonApiIp, } from '../../../../config/constants.js'
import { Button, Divider } from 'semantic-ui-react'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import { checkAdminEmail } from '../../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import Status from '../../../../config/OrderStatusConstants.js'
import * as UiConsts from '../../../../config/UiConstants';

class WhatsappPermission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: ''
        }
    }

    componentDidMount() {
        // console.log("++++++++++:DepositReminder");
        // console.log("this.props.order.key:" + this.props.order.key);
   
    }

    sendOptin = (sentType) => {

        this.setState({loading:true})

        axios.post(pythonApiIp + 'sendOptin', {
            apiKey: 'asdfasdfsf',
            phone: this.props.order.phone,
            templateName: 'allow_messages',
            itemType: this.props.order.itemType,
            order_num: this.props.order.order_num
        })
            .then((response) => {
                this.setState({loading:false})
                console.log(response.data);
            })
            .catch((error) => {
                this.setState({loading:false})
                console.log(error);
            });

        var d = new Date();
        let now = moment().format('MMMM Do, h:mm:ss a');

        let orderUpdates = {
            whatsapp_approvalsent: true,
            whatsapp_approvalsent_on: now,
            whatsapp_approvalsent_by: this.props.user.email,
        }

        //upATE MAIN ORDER
        FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdates);
    }

    render() {

        const getWhatappPermissionButton = (this.props.order.status == Status.designing_started 
            || this.props.order.status == Status.clnt_chckng_dsgn || this.props.order.status == Status.clnt_rejectd_dsgn) 
            ? <Button type='Button' icon='whatsapp' onClick={this.sendOptin} type='button' color='green' fluid size='medium'>GET WHATSPP APPROVAL</Button>
            : ''

        const wholeUI = this.props.algoliaUser && this.props.algoliaUser.sendWhatsapp
            ? <div>
                <Divider>{'WHATSAPP PERMISSION'}</Divider>
                {getWhatappPermissionButton}

            </div>
            : ""

        const sentOptinButton = this.props.order.whatsapp_Perm_Checked && this.props.order.whatsapp_okToSendImage == 'no'
         ? <Button type='Button' icon='whatsapp' onClick={this.sendOptin} type='button' color='blue' size='small '>GET WHATSPP APPROVAL</Button>
         :''

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                {/* {wholeUI} */}
                {sentOptinButton}
            </div>
        )
    }
}

export default WhatsappPermission;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/WhatsappPermission.js